<template>
    <div v-loading="loading">
        <div class="header-btn">
            <el-button size="small" type="warning" @click="openCreate" icon="el-icon-plus"></el-button>
        </div>

        <el-table
                stripe
                highlight-current-row
                :data="data"
                style="width: 100%">
            <el-table-column v-for="item in [
                    {prop:'name',label:'Company Name'},
                    {prop:'contactName',label:'Contact Name'},
                    {prop:'email',label:'Email'},
                    {prop:'city',label:'City'},
                       ]"
                             :prop="item.prop"
                             :label="item.label"
                             :key="item.label">
            </el-table-column>

            <el-table-column
                    label="Date Updated">
                <template slot-scope="s">
                    {{s.row.updated|dateFmt}}
                </template>
            </el-table-column>

            <el-table-column label="Action" width="160x" align="center">
                <template slot-scope="s">
                    <el-button type="primary" circle icon="el-icon-edit" @click="edit(s.row)"></el-button>
                    <el-button type="danger" circle icon="el-icon-delete"
                               @click="deleteData(s.row.id)"></el-button>
                </template>
            </el-table-column>
        </el-table>

        <el-dialog
                v-if="dialogVisible"
                :close-on-click-modal="false"
                :visible.sync="dialogVisible"
                center width="700px">
            <el-form ref="contractor" :model="company" label-position="left" label-width="150px" :rules="rules">
                <el-form-item label="Company Name" prop="name">
                    <el-input v-model="company.name"></el-input>
                </el-form-item>

                <el-form-item label="Company UEN" prop="uen">
                    <el-input v-model="company.uen"></el-input>
                </el-form-item>

                <el-form-item label="Service Type" prop="serviceType">
                    <el-select v-model="company.serviceType" placeholder="Select service types" multiple>
                        <el-option
                                v-for="item in serviceType"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="Contact Name">
                    <el-input v-model="company.contactName"></el-input>
                </el-form-item>

                <el-form-item label="Email">
                    <el-input v-model="company.email"></el-input>
                </el-form-item>

                <el-form-item label="Mobile Number">
                    <el-input v-model="company.mobile"></el-input>
                </el-form-item>

                <el-form-item label="Telephone">
                    <el-input v-model="company.telephone"></el-input>
                </el-form-item>

                <el-form-item label="Address 1">
                    <el-input v-model="company.addressOne"></el-input>
                </el-form-item>

                <el-form-item label="Address 2">
                    <el-input v-model="company.addressTwo"></el-input>
                </el-form-item>

                <el-form-item label="City">
                    <el-input v-model="company.city"></el-input>
                </el-form-item>

                <el-form-item label="State">
                    <el-input v-model="company.state"></el-input>
                </el-form-item>
            </el-form>

            <span slot="footer">
                <el-button type="primary" @click="save()">Save</el-button>
                <el-button @click="dialogVisible = false">Cancel</el-button>
            </span>
        </el-dialog>

        <div class="page">
            <el-pagination v-if="page.total>1"
                           @current-change="loadData"
                           :page-size="page.size"
                           :current-page.sync="page.page"
                           :page-count="page.totalPage"
                           layout="prev, pager, next"
                           :total="data.total">
            </el-pagination>
        </div>
    </div>
</template>

<script>
    import {company, saveCompany, updatedCompany, deleteCompany} from '@/api/CompanyAPI'

    export default {
        name: 'Company',
        data() {
            return {
                rules: {
                    name: [
                        {required: true, message: 'Name is required', trigger: 'blur'}
                    ]
                },
                page: {'page': 1, 'size': 10, 'totalPage': 1, 'total': 0},
                loading: false,
                data: [],
                dialogVisible: false,
                company: {},
                serviceType: [
                    {label: 'Security', value: 'Security'},
                    {label: 'Cleaning', value: 'Cleaning'},
                    {label: 'Landscape', value: 'Landscape'},
                    {label: 'Swimming Pool', value: 'Swimming Pool'},
                    {label: 'Pest Control', value: 'Pest Control'},
                ],
                status: [
                    {}
                ]
            }
        },
        methods: {
            save() {
                const action = this.company.id ? updatedCompany : saveCompany
                action(this.company).then(() => {
                    this.dialogVisible = false
                    this.loadData()
                })
            },
            deleteData(id) {
                this.$deleteRequest(this, deleteCompany, id)

            },
            openCreate() {
                this.company = {}
                this.dialogVisible = true
            },
            loadData() {
                this.$pageUtils(this, company)
            },
            edit(data) {
                this.company = JSON.parse(JSON.stringify(data))
                this.company.serviceType = JSON.parse(this.company.serviceType)
                this.dialogVisible = true
            }
        },
        mounted() {
            this.loadData()
        }
    }
</script>

<style scoped>
    .el-button{
        margin: 0 5px 0 0;
    }
</style>
